<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="'100%'" nzCentered
    [nzVisible]="isVisibleSwitchAccountModal" [nzTitle]="switchTitle" [nzFooter]="switchAccountFooter"
    (nzOnCancel)="handleCancel()" [nzClassName]="!isSiteSelected ? 'hideClose switc-ac-modal' : 'switc-ac-modal'"
    [nzClosable]="isSiteSelected">

    <ng-template #switchTitle>
        <div class="d-flex justify-content-space-between switch-title-row">
            <div>
                Switch Account
            </div>
            <!-- No supplier is picked here, so no Settings strip; User Profile / Security open the /account pages. -->
            <div class="mr-4 switch-user-menu">
                <app-profile-menu [user]="userInfo" (signOut)="signOut()"></app-profile-menu>
            </div>
        </div>
    </ng-template>

    <ng-container *nzModalContent class="h-100">
        <div *ngIf="!noAccountsAssigned" class="searchBar">
            <nz-input-group [nzSuffix]="suffixIconSearch" class="w-380">
                <input type="text" nz-input placeholder="Search" [(ngModel)]="searchText"
                    (ngModelChange)="onSearch($event)" />
            </nz-input-group>
            <ng-template #suffixIconSearch>
                <nz-icon nzType="search" />
            </ng-template>
        </div>
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="justify-content-center">
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                <div class="d-flex flex-wrap scrollable-container" style="justify-content: center;">

                    <!--------------- Accounts Dropdown ------------------->
                    <div class="mr-1" style="margin-bottom:auto;">
                        <h1 class="page-title-text sites-text center fs-35" *ngIf="isVisibleAccountFilter">Accounts</h1>
                        <nz-select nzShowSearch nzPlaceHolder="Select Account" [nzSize]="'default'"
                            [(ngModel)]="selectedAccount" *ngIf="isVisibleAccountFilter" class="w-380"
                            style="margin-bottom:30px;display: table;margin-left: auto;margin-right: auto;"
                            (ngModelChange)="onSelectAccount($event)" [nzSelectOnTab]="true"
                            [nzFilterOption]="customFilterFn">
                            <ng-container *ngIf="!isDataLoaded">
                                <nz-option *ngFor="let option of listOfAccounts" [nzLabel]="option.accountName"
                                    [nzValue]="option.accountId"></nz-option>
                            </ng-container>
                            <nz-option *ngIf="isDataLoaded" nzDisabled nzCustomContent>
                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                Loading Data...
                            </nz-option>
                        </nz-select>
                        <div class="justify-content-center mobile-d-flex-none" style="margin-bottom:auto ;">
                            <ng-container *ngFor="let site of listOfAllocatedSites">
                                <div class="website-logo">
                                    <a (click)="navigateToPaybevLandingPage(site.siteId)">
                                        <nz-avatar [nzText]="site.siteName.charAt(0).toUpperCase()"
                                            [nzSrc]="site.siteProfile" [nzSize]="150"></nz-avatar><br>
                                        <span class="site-name-text Font-Regular lh-25">{{site.siteName}}</span>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!--------------- Supplier Dropdown ------------------->
                    <div class="mr-1" style="margin-bottom:auto;">
                        <h1 class="page-title-text sites-text center fs-35" *ngIf="isVisibleSupplierFilter">Supplier
                        </h1>
                        <nz-select nzShowSearch nzPlaceHolder="Select Account" [nzSize]="'default'"
                            [(ngModel)]="selectedSupplier" *ngIf="isVisibleSupplierFilter" class="w-380"
                            style="margin-bottom:30px;display: table;margin-left: auto;margin-right: auto;"
                            (ngModelChange)="onSelectSupplier($event)" [nzSelectOnTab]="true"
                            [nzFilterOption]="customFilterFn">
                            <ng-container *ngIf="!isDataLoaded">
                                <nz-option *ngFor="let option of listOfSuppliers" nzCustomContent
                                    [nzLabel]="option.investorDisplayName" [nzValue]="option.id">

                                    <span class="d-flex justify-content-space-between align-items-c w-100"><span
                                            class="ellipsis-text">{{option?.investorDisplayName}}</span>
                                        <span *ngIf="option?.isSiteInvestor" class="program-box m-0 w-55"> Unlinked
                                        </span></span></nz-option>
                            </ng-container>
                            <nz-option *ngIf="isDataLoaded" nzDisabled nzCustomContent>
                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                Loading Data...
                            </nz-option>
                        </nz-select>
                        <div class=" justify-content-center mobile-d-flex-none" style="margin-bottom:auto ;">
                            <ng-container *ngFor="let supplier of listOfSupplierAllocatedSites">
                                <div class="website-logo">
                                    <a (click)="navigateToLandingPage(supplier)">
                                        <nz-avatar *ngIf="!supplier.profileImageUrl"
                                            [nzText]="supplier.investorDisplayName.charAt(0).toUpperCase()"
                                            class="supplierLogoAvatar" nzShape="square"></nz-avatar><br>
                                        <!-- class="supplierLogoAvatar"  -->
                                        <img *ngIf="supplier.profileImageUrl" [src]="supplier.profileImageUrl"
                                            class="supplierLogoImage" alt="Supplier Logo"><br>
                                        <span
                                            class="site-name-text Font-Regular lh-25">{{supplier.investorDisplayName}}</span>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!--------------- Supplier Bank Dropdown ------------------->
                    <div class="" style="margin-bottom:auto;">
                        <h1 class="page-title-text sites-text center fs-35" *ngIf="isVisibleSupplierBankFilter">Supplier
                            Bank</h1>
                        <nz-select nzShowSearch nzPlaceHolder="Select Account" [nzSize]="'default'"
                            [(ngModel)]="selectedSupplierBank" *ngIf="isVisibleSupplierBankFilter" class="w-380"
                            style="margin-bottom:30px;display: table;margin-left: auto;margin-right: auto;"
                            (ngModelChange)="onSelectSupplierBank($event)" [nzSelectOnTab]="true"
                            [nzFilterOption]="customFilterFn">
                            <ng-container *ngIf="!isDataLoaded">
                                <nz-option *ngFor="let option of listOfSupplierBanks" [nzLabel]="option.accountName"
                                    [nzValue]="option.accountId"></nz-option>
                            </ng-container>
                            <nz-option *ngIf="isDataLoaded" nzDisabled nzCustomContent>
                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                Loading Data...
                            </nz-option>
                        </nz-select>
                        <div class=" justify-content-center mobile-d-flex-none" style="margin-bottom:auto ;">
                            <ng-container *ngFor="let site of listOfSupplierBankAllocatedSites">
                                <div class="website-logo">
                                    <a (click)="navigateToPaybevLandingPage(site.siteId)">
                                        <nz-avatar [nzText]="site.siteName.charAt(0).toUpperCase()"
                                            [nzSrc]="site.siteProfile" [nzSize]="150"></nz-avatar><br>
                                        <span class="site-name-text Font-Regular lh-25">{{site.siteName}}</span>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="noAccountsAssigned" class="noAccountsText">
                        No accounts assigned, please contact your administrator.
                    </div>
                </div>

            </div>
            <div *ngIf="isDataLoaded">
                <nz-spin [nzSize]="'large'"></nz-spin>
            </div>

            <div *ngIf="NoSearchRecordFound" class="fs-22">
                <!-- <i nz-icon nzType="inbox" nzTheme="outline" class="fs-"></i><br> -->
                No search record found.
            </div>
        </div>
    </ng-container>
    <ng-template #switchAccountFooter>
    </ng-template>
</nz-modal>